// utils/calculate.js

/**
 * 计算单行合计
 * @param {Object} row - 行数据
 * @param {number} row.num - 数量
 * @param {number} row.price - 单价
 * @returns {number} 合计金额
 */
const sumRowNum = (row) => {
  row.total = row.num * row.price
  return row.num * row.price
}
/**
 * 计算单行合计
 * @param {Object} row - 行数据
 * @param {number} row.num - 数量
 * @param {number} row.price - 单价
 * @returns {number} 合计金额
 */
const sumPCBuildRowNum = (row) => {
  row.hj = row.sl * row.dj
  return row.sl * row.dj
}
/**
 * 计算单行合计
 * @param {Object} row - 行数据
 * @param {number} row.sl - 数量
 * @param {number} row.price - 单价
 * @returns {number} 合计金额
 */
const sumPCBuildChengBenRowNum = (row) => {
  row.chengbenHeji = row.sl * row.chengbenjia
  return row.sl * row.chengbenjia
}
/**
 * 计算列表中某个字段的总和
 * @param {Array} list - 数据列表
 * @param {string} field - 字段名
 * @returns {string} 格式化后的总和（保留两位小数）
 */
const sumNum = (list, field) => {
  let count = 0
  list.forEach((item) => {
    count += Number(item[field])
  })
  return count.toFixed(2)
}

export { sumRowNum, sumNum ,sumPCBuildRowNum,sumPCBuildChengBenRowNum}